import React from 'react'
import PropTypes from 'prop-types'

import Header from './Header'
import Form from './Form'

const Address = (props) => {
  const { handleStep, handleStepOnMode, handleAddress, step, stepOnMode, address } = props
  const headerProps = { step, handleStep, stepOnMode, handleStepOnMode, address }

  return (
    <div className='row mx-0'>
      <Header {...headerProps} />
      {
        (step === 1 && (stepOnMode === 'add' || stepOnMode === 'edit')) && (<Form handleStep={handleStep} handleAddress={handleAddress} address={address} {...props} />)
      }
    </div>
  )
}

Address.propTypes = {
  handleStep: PropTypes.func,
  handleStepOnMode: PropTypes.func,
  handleAddress: PropTypes.func,
  step: PropTypes.number.isRequired,
  stepOnMode: PropTypes.string,
  address: PropTypes.object
}

export default Address



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/Address.js